import { VCol } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mx-2", staticStyle: { width: "100%" } },
    [
      _c(
        VCol,
        { attrs: { cols: "12" } },
        [_c("app-title", { attrs: { texto: "ATUAÇÃO PROFISSIONAL" } })],
        1
      ),
      _vm._l(_vm.filtro, function (f) {
        return _c(
          VCol,
          { key: f.titulo, attrs: { cols: "12" } },
          [_c("filtro-base", { attrs: { value: f } })],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }